define(["require", "exports", "../../core/bootstrap/BootstrapBus"], function (require, exports, BootstrapBus_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LogsManager = exports.ERROR_TYPE = void 0;
    var ERROR_TYPE;
    (function (ERROR_TYPE) {
        ERROR_TYPE[ERROR_TYPE["UNHANDLEDREJECTION_ERROR"] = 1] = "UNHANDLEDREJECTION_ERROR";
        ERROR_TYPE[ERROR_TYPE["ONERROR_ERROR"] = 2] = "ONERROR_ERROR";
        ERROR_TYPE[ERROR_TYPE["VUE_ERROR"] = 3] = "VUE_ERROR";
        ERROR_TYPE[ERROR_TYPE["NETWORK_ERROR"] = 4] = "NETWORK_ERROR";
        ERROR_TYPE[ERROR_TYPE["BUSINESS_ERROR"] = 5] = "BUSINESS_ERROR";
    })(ERROR_TYPE = exports.ERROR_TYPE || (exports.ERROR_TYPE = {}));
    var LogsManager = (function () {
        function LogsManager() {
            this._logsQuene = [];
        }
        LogsManager.prototype.monitor = function (vueObj) {
            var _this = this;
            window.addEventListener('unhandledrejection', function (event) {
                event.promise.catch(function (e) {
                    _this.catchError(e, ERROR_TYPE.UNHANDLEDREJECTION_ERROR);
                });
            });
            window.onerror = function (errorMessage, scriptURI, lineNo, columnNo, error) {
                if (error) {
                    error.url = error.stack;
                    console.log('caught..SyntaxError: Unexpected token');
                    var stack = error.stack;
                    if (stack && stack.indexOf("SyntaxError: Unexpected token '<'") !== -1) {
                        if (scriptURI && scriptURI.indexOf('.js') !== -1) {
                            console.log('caught..SyntaxError: Unexpected token RELOAD');
                            window.location.reload();
                        }
                    }
                }
                _this.catchError(error, ERROR_TYPE.ONERROR_ERROR);
            };
            vueObj.config.errorHandler = function (err, vm, info) {
                if (err) {
                    err.url = err.stack;
                }
                this.catchError(err, ERROR_TYPE.VUE_ERROR);
            };
        };
        LogsManager.prototype.interceptLogs = function (response) {
            if (response && response.data && response.data.code) {
                var code = response.data.code.toString();
                if (code.length > 0) {
                    var codeList = code.split('');
                    var codeStatus = codeList[0];
                    if (codeStatus !== '0') {
                        var errorReportItem = {
                            stackStr: '-1',
                            message: response.data.msg || '',
                            script: '-1',
                            line: response.data.code,
                            column: '-1',
                            type: ERROR_TYPE.BUSINESS_ERROR
                        };
                        BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_TIPS_UPDATE, errorReportItem);
                        this.addLogsToReport(errorReportItem);
                    }
                }
            }
        };
        LogsManager.prototype.addNetworkLogs = function (error) {
            if (!error || !error.config) {
                return;
            }
            var errorReportItem = {
                stackStr: error.stack,
                message: "".concat(error.message, ": ").concat(error.config.url),
                script: '-1',
                line: '-1',
                column: '-1',
                type: ERROR_TYPE.NETWORK_ERROR
            };
            this.addLogsToReport(errorReportItem);
        };
        LogsManager.prototype.catchError = function (error, errorType) {
            if (!error) {
                return;
            }
            var errorReportItem = {};
            errorReportItem.type = errorType;
            switch (errorType) {
                case ERROR_TYPE.UNHANDLEDREJECTION_ERROR:
                    errorReportItem.stackStr = '';
                    errorReportItem.message = error.reason;
                    errorReportItem.script = '';
                    errorReportItem.line = '';
                    errorReportItem.column = '';
                    break;
                case ERROR_TYPE.ONERROR_ERROR:
                    errorReportItem.stackStr = error.source;
                    errorReportItem.message = error.message;
                    errorReportItem.script = error.script;
                    errorReportItem.line = error.line;
                    errorReportItem.column = error.column;
                    break;
                case ERROR_TYPE.VUE_ERROR:
                    var message = error.message, name_1 = error.name, script = error.script, line = error.line, column = error.column, stack = error.stack;
                    var stackStr = stack ? stack.toString() : "".concat(name_1, ":").concat(message);
                    errorReportItem.stackStr = stackStr;
                    errorReportItem.message = message;
                    errorReportItem.script = script;
                    errorReportItem.line = line;
                    errorReportItem.column = column;
                    break;
            }
            this.addLogsToReport(errorReportItem);
        };
        LogsManager.prototype.addLogsToReport = function (errorReportItem) {
            this._logsQuene.push(errorReportItem);
            this.shiftQuene();
        };
        LogsManager.prototype.shiftQuene = function () {
            if (this._logsQuene.length) {
                console.log('输出截获日志: ', this._logsQuene.shift());
            }
        };
        return LogsManager;
    }());
    exports.LogsManager = LogsManager;
});
//# sourceMappingURL=LogsManager.js.map